export const globalStyles = {
  roundBorders: {
    border: '1px solid #dfdfdf',
    'border-radius': '.25rem'
  }
};
